import { TAddPlayerToGroup } from '../../../../../../store/admin/eventRounds/actions';
import { IRoundGame } from '../../../../../../store/admin/eventRounds/store';

import { isMobileResolution } from '../../../../../../contrib/utils';
import { IStateDispatchActions } from '../TeeSheetCreator.context';

const isMobile = isMobileResolution();

interface IOnPlayerAddAugmentedArgs {
  addPlayerToGroup: TAddPlayerToGroup;
  eventId: string | undefined;
  clubId: string | undefined;
  roundId: string | undefined;
}

export type IOnPlayerAddAugmented = (
  args: IOnPlayerAddAugmentedArgs
) => (game: Partial<IRoundGame>, groupId: number) => any;

export type IOnPlayerAdd = (game: Partial<IRoundGame>, groupId: number) => any;

export const onPlayerAdd: IStateDispatchActions<IOnPlayerAddAugmented> = (_, dispatch) => args => (
  game,
  groupId
) => {
  const { clubId, eventId, roundId, addPlayerToGroup } = args;

  if (isMobile) {
    dispatch({ type: 'set', value: { attribute: 'modalOpen', value: false } });
    dispatch({ type: 'set', value: { attribute: 'searchValue', value: '' } });
  }

  return addPlayerToGroup(Number(clubId), Number(eventId), Number(roundId), {
    ...game,
    group: groupId
  });
};
